import { useMutation, useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { Alert } from 'rsuite';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../../data';
import { getCattegories } from '../../../../../../services/ProdutoService_ts';
import { getMargemObjetivaSegmento } from '../../../../../IPA/Estrategia/pages/MargemObjetiva/services';
import { CategoryLevels } from '../lib/schema';
import { getMarginAndRoleCategoryCalculation, getOptimizationCategoryLevel, saveCategoryLevels } from '../lib/service';

export const useCategoryLevelsQuery = () => {
  const queryCategoriesLevel = useQuery({
    queryKey: ['ipa/setup/category-levels/levels'],
    queryFn: getCattegories,
  });

  const queryObjetiveMargin = useQuery({
    queryKey: ['ipa/setup/category-levels/objetive-margin'],
    queryFn: getMargemObjetivaSegmento,
  });

  const queryCategoryRole = useQuery({
    queryKey: ['ipa/setup/category-levels/margin-and-role-category'],
    queryFn: getMarginAndRoleCategoryCalculation,
  });

  const queryOptimizationCategory = useQuery({
    queryKey: ['ipa/setup/category-levels/optimization-category'],
    queryFn: getOptimizationCategoryLevel,
  });

  const { mutateAsync } = useMutation({
    mutationFn: saveCategoryLevels,
    onSuccess: () => {
      queryCategoriesLevel.refetch();
      queryCategoryRole.refetch();
      queryObjetiveMargin.refetch();
    },
  });

  const handleUpdateProductsSegmentation = useCallback(
    async (formData: CategoryLevels) => {
      try {
        const data = {
          categoryLevels: formData.categoryLevels.map(cat => {
            return {
              level: cat.level,
              name: cat.name,
            };
          }),
          categoryRoleLevel: formData.categoryRoleCalculation.level,
          objectiveMarginLevel: formData.objectiveMargin.level,
          optimizationCategory: formData.optimizationCategory.level,
        };

        await mutateAsync(data);
        Alert.success('Níveis de categoria salvas com sucesso');
      } catch (err) {
        const { message } = new Exception(err.message);
        AlertWithTimestamp({ message });
      }
    },
    [mutateAsync],
  );

  return {
    queriesData: {
      queryLevels: queryCategoriesLevel.data,
      queryCategoryRole: queryCategoryRole.data,
      queryObjetiveMargin: queryObjetiveMargin.data,
      queryOptimizationCategory: queryOptimizationCategory?.data,
    },
    isLoading: false,
    handlers: {
      update: handleUpdateProductsSegmentation,
    },
  };
};
